(function () {
  'use strict';
  var namespace = window.InkcloudFormSuccess = window.InkcloudFormSuccess || {};
  var initialized = namespace.initialized = namespace.initialized || {};
  var destroySection = namespace.destroySection = namespace.destroySection || {};
  var lockState = namespace.lockState = namespace.lockState || { count: 0, overflow: '' };
  function lockBody() { if (lockState.count === 0) { lockState.overflow = document.body.style.overflow; document.body.classList.add('inkcloud-form-success--locked'); } lockState.count += 1; }
  function unlockBody() { lockState.count = Math.max(0, lockState.count - 1); if (lockState.count === 0) { document.body.classList.remove('inkcloud-form-success--locked'); document.body.style.overflow = lockState.overflow; } }
  function initDialogsInSection(section, replaceExisting) {
    if (!section || !namespace.init) return;
    var dialogs = [];
    if (section.matches && section.matches('[data-inkcloud-form-success]')) dialogs.push(section);
    if (section.querySelectorAll) dialogs = dialogs.concat(Array.prototype.slice.call(section.querySelectorAll('[data-inkcloud-form-success]')));
    dialogs.forEach(function (dialog) {
      var sectionId = dialog.dataset.sectionId;
      if (!sectionId) return;
      if (destroySection[sectionId]) {
        if (!replaceExisting) return;
        destroySection[sectionId]();
      }
      namespace.init({ sectionId: sectionId, formType: dialog.dataset.formType });
    });
  }
  if (!namespace.sectionLoadBound) {
    document.addEventListener('shopify:section:load', function (event) { initDialogsInSection(event.target, true); });
    namespace.sectionLoadBound = true;
  }
  namespace.init = function (config) {
    if (!config || !config.sectionId || initialized[config.sectionId]) return;
    var section = document.getElementById('shopify-section-' + config.sectionId);
    var dialog = document.getElementById('InkcloudFormSuccess-' + config.sectionId);
    if (!section || !dialog || typeof dialog.showModal !== 'function') return;
    initialized[config.sectionId] = true;
    var teardown = [], wasSuccessful = false, closedForCurrentSuccess = false, previouslyFocused = null, isLocked = false;
    function closeDialog() { if (dialog.open) dialog.close(); }
    function openDialog() {
      if (closedForCurrentSuccess || dialog.open) return;
      if (namespace.activeDialog && namespace.activeDialog !== dialog && namespace.activeDialog.open) namespace.activeDialog.close();
      previouslyFocused = document.activeElement;
      dialog.showModal(); namespace.activeDialog = dialog;
      if (!isLocked) { lockBody(); isLocked = true; }
      var closeButton = dialog.querySelector('[data-inkcloud-form-success-close]');
      if (closeButton) closeButton.focus();
    }
    function isSuccessful(root) { var appEmbed = root.querySelector('#app-embed[data-current-step="success"]'); return Boolean(appEmbed && appEmbed.querySelector('[data-testid="banner-success"]')); }
    function inspect(root) { var successful = isSuccessful(root); if (successful && !wasSuccessful) openDialog(); if (!successful) closedForCurrentSuccess = false; wasSuccessful = successful; }
    var hydrationTimer = null, hydrationTimeout = null;
    function stopHydration() { if (hydrationTimer !== null) { window.clearInterval(hydrationTimer); hydrationTimer = null; } if (hydrationTimeout !== null) { window.clearTimeout(hydrationTimeout); hydrationTimeout = null; } }
    function observeEmbed(embed) {
      if (!embed.shadowRoot || embed.dataset.inkcloudFormSuccessObserved === 'true') return;
      embed.dataset.inkcloudFormSuccessObserved = 'true';
      var root = embed.shadowRoot, pending = false;
      var formIds = { distributor: '1166390', oem: '1166329' };
      function onSubmit(event) {
        if (event.target && event.target.tagName === 'FORM' && event.target.getRootNode() === root && !isSuccessful(root)) pending = true;
      }
      function inspectEmbed() {
        var successful = isSuccessful(root);
        if (successful && pending) {
          pending = false;
          var formId = Object.prototype.hasOwnProperty.call(formIds, config.formType) ? formIds[config.formType] : null;
          if (formId) {
            try { window.dataLayer = window.dataLayer || []; if (typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'inkcloud_lead_success', lead_type: config.formType, form_id: formId }); } catch (error) { /* Analytics must not affect the form. */ }
          }
        } else if (pending) {
          var app = root.querySelector('#app-embed[data-current-step]');
          var step = app && app.getAttribute('data-current-step');
          if ((step && step !== 'form' && step !== 'success') || root.querySelector('form [role="alert"], form [aria-invalid="true"]')) pending = false;
        }
        inspect(root);
      }
      root.addEventListener('submit', onSubmit, true);
      var shadowObserver = new MutationObserver(inspectEmbed);
      shadowObserver.observe(embed.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step', 'aria-invalid'] });
      teardown.push(function () { root.removeEventListener('submit', onSubmit, true); shadowObserver.disconnect(); delete embed.dataset.inkcloudFormSuccessObserved; }); stopHydration(); inspectEmbed();
    }
    function findEmbeds() { section.querySelectorAll('shopify-forms-embed').forEach(observeEmbed); }
    var sectionObserver = new MutationObserver(findEmbeds);
    sectionObserver.observe(section, { childList: true, subtree: true }); teardown.push(function () { sectionObserver.disconnect(); });
    hydrationTimer = window.setInterval(findEmbeds, 250);
    hydrationTimeout = window.setTimeout(stopHydration, 30000);
    teardown.push(stopHydration); findEmbeds();
    function onDialogClick(event) { if (event.target === dialog) closeDialog(); }
    function onDialogClose() { closedForCurrentSuccess = true; if (namespace.activeDialog === dialog) namespace.activeDialog = null; if (isLocked) { unlockBody(); isLocked = false; } if (previouslyFocused && typeof previouslyFocused.focus === 'function' && document.contains(previouslyFocused)) previouslyFocused.focus(); }
    var closeButtons = Array.prototype.slice.call(dialog.querySelectorAll('[data-inkcloud-form-success-close]'));
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('close', onDialogClose);
    closeButtons.forEach(function (button) { button.addEventListener('click', closeDialog); });
    teardown.push(function () { dialog.removeEventListener('click', onDialogClick); dialog.removeEventListener('close', onDialogClose); closeButtons.forEach(function (button) { button.removeEventListener('click', closeDialog); }); });
    function destroy() { closeDialog(); teardown.forEach(function (dispose) { dispose(); }); if (isLocked) { unlockBody(); isLocked = false; } document.removeEventListener('shopify:section:unload', onSectionUnload); delete destroySection[config.sectionId]; delete initialized[config.sectionId]; }
    function onSectionUnload(event) { if (event.detail && event.detail.sectionId === config.sectionId) destroy(); }
    document.addEventListener('shopify:section:unload', onSectionUnload);
    destroySection[config.sectionId] = destroy;
    var removalObserver = new MutationObserver(function () { if (!document.documentElement.contains(section)) destroy(); });
    removalObserver.observe(document.body, { childList: true, subtree: true }); teardown.push(function () { removalObserver.disconnect(); });
  };
  function initializeOnReady() { initDialogsInSection(document, false); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeOnReady, { once: true });
  else initializeOnReady();
}());
